module.exports = " <section class=todo> <h1>Todo List</h1> <form class=todo__form @submit.prevent=add> <input v-model=newTodo type=text placeholder=\"new todo\"/> <button class=todo__btn type=submit>Add</button> </form> <ul class=todo__list> <li v-for=\"todo in todos\">{{ todo.text }} <button class=todo__btn @click=remove(todo) type=button>Delete</button></li> </ul> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/components/Todo.vue
 ** module id = 129
 ** module chunks = 1
 **/